import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { PriceDiscountPipe } from '@modules/shared/pipes/price-discount.pipe';
import { CommonEnums } from '@enums/comman.enums';
import {
  Labels,
  Messages
} from '@modules/shared/components/vip-offer-list/constant';
import { AlertModalComponent } from '@components/alert-modal/alert-modal.component';
import { ButtonComponent } from '@components/button/button.component';
import { ProfileDetailComponent } from '@components/profile-detail/profile-detail.component';
import { OnChanges } from '@angular/core';
import { Fields } from '@constants/constant';
import { Application } from '@enums/application.enums';
@Component({
  selector: 'app-subscription-plan-duration-modal',
  templateUrl: './subscription-plan-duration-modal.component.html',
  styleUrls: ['./subscription-plan-duration-modal.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    AlertModalComponent,
    ProfileDetailComponent,
    ButtonComponent,
    PriceDiscountPipe
  ]
})
export class SubscriptionPlanDurationModalComponent implements OnChanges {
  @Input() contentType: string = 'offer';
  @Input() modalHeader: string;
  @Input() curSelectedSubscription = null;
  @Input() userProfile = null;
  @Input() selectedPlan = null;
  @Input() headerType = '';
  @Input() modalOptions = {};
  @Output() confirmed = new EventEmitter<void>();
  @Output() canceled = new EventEmitter<void>();
  @Output() handlePlanSelect = new EventEmitter();

  @ViewChild('subscriptionDuration') subscriptionDurationModal;

  labels = Labels;
  messages = Messages;
  Application = Application;
  ngOnChanges() {
    if (this.curSelectedSubscription && !this.selectedPlan) {
      this.selectedPlan = this.curSelectedSubscription.plan_details[0];
      this.selectPlan(this.selectedPlan);
    }
  }
  getDurationLabel(plan) {
    return `${plan?.duration} ${CommonEnums.MONTH}${
      plan?.duration !== 1 ? 's' : ''
    }`;
  }

  durationBtnField(plan) {
    const label = this.getDurationLabel(plan);
    return {
      label,
      class:
        this.selectedPlan?.duration === plan.duration
          ? 'btn btn-primary'
          : 'btn btn-primary btn-outlined'
    };
  }

  subscribePlan() {
    this.confirmed.emit();
  }
  selectPlan(plan) {
    this.handlePlanSelect.emit(plan);
  }
  get fullName() {
    return `${this.userProfile?.first_name || ''} ${
      this.userProfile?.last_name || ''
    }`.trim();
  }
  openModal() {
    this.subscriptionDurationModal?.openModal();
  }
  closeModal() {
    this.subscriptionDurationModal?.closeModal();
  }
  get confirmBtnDynamicLabel(): string {
    if (!this.selectedPlan) return this.labels.SELECT;

    if (this.selectedPlan?.trial_enable && this.selectedPlan?.trial_days>0) {
      const days = this.selectedPlan?.trial_days;
      return `${Fields.START} ${days}-${Fields.DAY} ${Fields.FREE_TRIAL}`;
    }

    return this.labels.SELECT;
  }


  handleCancel() {
    this.canceled.emit();
  }
}
